import React, { useEffect, useState } from "react";
import Picky from "react-picky";
import "react-picky/dist/picky.css";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { selectUserPermisionData } from "../../features/rolebase/userPermissionSlice";

const MultiSelectCompany= ({optionList,setId,selectedValue,labelKey,valueKey,isAdd}
  :{optionList:any,setId:any,selectedValue:any,labelKey:string,valueKey:string,isAdd:any})=> {
    
  const UserPermision = useAppSelector(selectUserPermisionData);
  const [value, setValue]=useState(null)
  const [arrayValue, setArrayValue]=useState([])
  const userDetails = localStorage.getItem("userDetails");
  const userDetailsList: any = userDetails;
  const policySourceType = JSON.parse(userDetailsList);
  const selectedCompanyId=policySourceType?.companyId

 const  selectMultipleOption=(value:any)=> {
   setArrayValue(value)
   setId(value?.map((x:any) => x?.id));
  }
  useEffect(()=>{
    //console.log(selectedValue,"====",optionList)
    if(isAdd===true){
      if(UserPermision?.roleId===5){
        setArrayValue(    
          optionList?.filter((item:any) => {
          if (selectedCompanyId?.includes(item.id)) {
            return item
          }
         }))  
      }else{
        //console.log(optionList?.map((x:any) => x?.id),"optionList?.map((x:any) => x?.id)")
        setArrayValue(optionList)
      }
    }else{      
      setArrayValue(    
          optionList?.filter((item:any) => {
          if (selectedValue?.includes(item.id)) {
            return item
          }
    }))    
  }
  },[])

    return (
      <Picky
        value={arrayValue}
        options={optionList}
        onChange={selectMultipleOption}
        open={false}
        valueKey={"id"}
        labelKey={labelKey}
        multiple={true}
        includeSelectAll={true}
        includeFilter={true}
        dropdownHeight={600}
      />
    );
  }


export default MultiSelectCompany;
